import TListItemProps from "../../../../../../components/Navigation/ListItem/types/TListItemProps";
import { DriveFileRenameOutline } from "@mui/icons-material";
import { TSectionProps } from "../../types/TSectionProps";
import IconImage from "../../../../../../components/Icon/IconImage/IconImage";

const CustomFieldsListItem = (props: TSectionProps) =>
  ({
    id: "CustomFieldsListItem",
    name: "Custom Fields",
    icon: (
      <IconImage
        imgDark="/app-v2/assets/Custom-Fields-Light.svg"
        img="/app-v2/assets/Custom-Fields-Dark.svg"
        size={16}
      />
    ),
    path: "/settings/customFields",
    navigateToPath: true,
    onNavigate: props.onClick,
    isDisabled: props.isDisabled,
    disabledTooltipMessage: props.disabledTooltipMessage,
  } as TListItemProps);

export default CustomFieldsListItem;
